import type { TUnidadesDeNegocioDisponiveisData } from '@/features/regionais/interfaces/unidade-de-negocio.types'
import { useLocalStorage } from '@/shared/hooks'
import type { TUsuarioLogado } from '@/shared/interfaces/user'

export const useTrocaRegional = (user: TUsuarioLogado) => {
  const [_, setUser] = useLocalStorage<TUsuarioLogado>('user', user)
  const regionalAtual = {
    id: user.unidadeDeNegocioId,
    nome: user.unidadeDeNegocio,
    empresaId: user.empresaId,
    principal: true,
  }

  const handleRegionalChange = (regional?: TUnidadesDeNegocioDisponiveisData) => {
    if (!regional) return
    setUser((prev) => ({
      ...prev,
      unidadeDeNegocio: regional.nome,
      unidadeDeNegocioId: regional.id,
      empresaId: regional.empresaId,
    }))
  }

  return { regionalAtual, handleRegionalChange }
}
